var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._t("default")],2)]}}],null,true)},[_c('fs1-span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }